import { Link } from 'react-router-dom';
import './PrivacyPage.css';

const SECTIONS = [
  {
    title: 'Who we are',
    body: [
      'This website is operated by Andrea Fagioli, independent creative director and developer.',
      'Website: andreafagioli.com',
    ],
  },
  {
    title: 'What data we collect',
    body: [
      'When you use the contact form, we collect the information you provide: your email address, subject line and message content.',
      'We do not use analytics or advertising trackers on this site at the time of writing.',
    ],
  },
  {
    title: 'Why we use it',
    body: [
      'Your message is used solely to read, respond to and follow up on your enquiry.',
      'Legal basis: your consent when submitting the form, and our legitimate interest in managing professional correspondence.',
    ],
  },
  {
    title: 'How data is processed',
    body: [
      'Messages are sent through a secure server endpoint and delivered via Resend (resend.com) to our email inbox.',
      'Cloudflare Turnstile is used on the form to reduce spam. We do not sell or share your data with third parties for marketing.',
    ],
  },
  {
    title: 'How long we keep it',
    body: [
      'Contact messages are kept in our email archive for as long as needed to handle the enquiry and for reasonable professional record-keeping, then deleted when no longer required.',
    ],
  },
  {
    title: 'Your rights',
    body: [
      'Under applicable privacy law (including GDPR where relevant), you may request access, correction or deletion of your personal data.',
      'To exercise these rights, contact us through the contact form on this website.',
    ],
  },
  {
    title: 'Updates',
    body: [
      'This policy may be updated occasionally. The current version is always available on this page.',
      'Last updated: June 2026.',
    ],
  },
];

const PrivacyPage = () => (
  <main className="privacy-page" data-testid="privacy-page">
    <Link to="/" className="privacy-back" aria-label="Back to homepage">
      ← Home
    </Link>

    <header className="privacy-header">
      <span className="privacy-strip">— Legal</span>
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="privacy-lead">
        A short note on how this site handles contact form data. No banners, no tracking. Just what you need to know.
      </p>
    </header>

    <div className="privacy-sections">
      {SECTIONS.map((section) => (
        <section key={section.title} className="privacy-section">
          <h2 className="privacy-section-title">{section.title}</h2>
          {section.body.map((paragraph) => (
            <p key={paragraph} className="privacy-section-body">
              {paragraph}
            </p>
          ))}
        </section>
      ))}
    </div>

    <footer className="privacy-footer">
      <Link to="/" className="privacy-footer-link">
        ← Back to homepage
      </Link>
    </footer>
  </main>
);

export default PrivacyPage;
